<script setup lang="ts">
/**
 * RinganAjakanKompresBanyak — ajakan jujur dari alat kompres GRATIS ke SKU
 * berbayar "Kompres Banyak".
 *
 * Versi RINGAN (tanpa Nuxt UI) khusus halaman kompres SEO. Pesannya lugas dan
 * jujur: gratis tetap 1 berkas; banyak berkas sekaligus = berbayar. Harga
 * mengikuti katalog (kb-30, Rp5.000 — harga yang disetujui pemilik).
 *
 * <CaCard> dipakai langsung (murni utility CSS, tidak menyentuh Nuxt UI).
 */
withDefaults(defineProps<{ ke?: string }>(), { ke: '/harga#kompres-banyak' })
</script>

<template>
  <CaCard tone="plain" class="relative overflow-hidden">
    <div class="grid gap-5 lg:grid-cols-[1fr_auto] lg:items-center lg:gap-8">
      <div class="min-w-0">
        <RinganLencana tone="netral" icon="wallet">Kompres Banyak</RinganLencana>
        <p class="ca-h3 mt-3 text-ink text-balance">Punya banyak foto atau PDF?</p>
        <p class="mt-2.5 text-[0.9375rem] text-ink leading-relaxed">
          Alat ini <strong>gratis untuk 1 berkas</strong>. Kalau berkasnya banyak,
          kompres puluhan sekaligus jadi satu file ZIP — <strong>mulai Rp5.000</strong>
          untuk 30 berkas. Satu kredit untuk satu berkas, dipakai kapan saja.
        </p>
      </div>
      <RinganTombol variant="secondary" size="lg" :to="ke" class="shrink-0">
        Lihat Kompres Banyak
      </RinganTombol>
    </div>
  </CaCard>
</template>
